export default class LaptopSetupNavigatorEvent {
    /**
     * @constructor
     * @param {String} type 
     * @param {createjs.Container} contextView 
     * @param {createjs.Point} size 
     */
    constructor(type, contextView, size) {
        this.type = type;
        this.contextView = contextView;
        this.size = size;
    }
}

LaptopSetupNavigatorEvent.PERFORM = "LaptopSetupNavigatorEvent.PERFORM";